<script setup>
import { computed } from "vue";

// rows: [{ user, assistant, system }] as percentages summing to 100
const props = defineProps({
  rows: { type: Array, required: true },
  colors: { type: Object, default: () => ({ user: "#38bdf8", assistant: "#34d399", system: "#fbbf24" }) },
  height: { type: Number, default: 200 },
});

const W = 600;
const H = 200;
const pad = { t: 10, b: 14, l: 6, r: 6 };

const rects = computed(() => {
  const n = props.rows.length;
  const bw = (W - pad.l - pad.r) / n;
  const avail = H - pad.t - pad.b;
  const out = [];
  props.rows.forEach((row, i) => {
    const x = pad.l + i * bw + bw * 0.16;
    const w = bw * 0.68;
    let yTop = pad.t;
    [
      [row.user, props.colors.user],
      [row.assistant, props.colors.assistant],
      [row.system, props.colors.system],
    ].forEach(([val, color], pi) => {
      const h = avail * (val / 100);
      out.push({ x: x.toFixed(1), y: yTop.toFixed(1), w: w.toFixed(1), h: h.toFixed(1), color, rx: pi === 0 ? 2 : 0 });
      yTop += h;
    });
  });
  return out;
});
</script>

<template>
  <svg class="an-chart" :style="{ height: height + 'px' }" :viewBox="`0 0 ${W} ${H}`" preserveAspectRatio="none">
    <rect
      v-for="(r, i) in rects"
      :key="i"
      :x="r.x"
      :y="r.y"
      :width="r.w"
      :height="r.h"
      :rx="r.rx"
      :fill="r.color"
    />
  </svg>
</template>
